import React from 'react';
import { useTranslation } from 'react-i18next';

interface ContactButtonProps {
  handleOpenContactModal: () => void;
  className?: string;
}

const ContactButton: React.FC<ContactButtonProps> = ({ handleOpenContactModal, className }) => {
  const { t } = useTranslation();
  
  return (
    <button
      className={`contact-button ${className || ""}`}
      onClick={handleOpenContactModal}
    >
      {t('contactSection.button', 'Contact')}
    </button>
  );
};

export default ContactButton;